import Grid from '@mui/material/Unstable_Grid2';
import ProductCardSkeleton from '../ProductCardSkeleton';

export default function ProductListSkeleton() {
	return (
		<Grid container rowSpacing={3} columnSpacing={2}>
			{Array.from({ length: 8 }).map(() => (
				<Grid xs={12} sm={6} md={3} key={crypto.randomUUID()}>
					<ProductCardSkeleton />
				</Grid>
			))}
		</Grid>
	);
}
